import preval from "preval.macro";


const buildTimestamp:number = preval`module.exports = new Date().getTime();`;

class TheAppData{

    debugMode:boolean=true;


    
    buildDate:Date = new Date(buildTimestamp);
}

const AppData:TheAppData = new TheAppData();
export default AppData;